const formatPrice = (value) =>
  `$${value.toLocaleString("es-AR", { minimumFractionDigits: 0 })}`;

const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const toDomId = (value) =>
  String(value || "producto")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "producto";

export const getPriceForPresentation = (producto) => {
  return producto.priceBase || producto.precioBase || producto.price || 0;
};

export const renderCatalog = ({
  targetSelector,
  productos,
  isStoreOpen = true,
}) => {
  const target = document.querySelector(targetSelector);
  if (!target) return;

  if (!productos.length) {
    target.innerHTML = `
      <div class="catalogo-empty" role="status">
        <div class="catalogo-empty__icon" aria-hidden="true">🍕</div>
        <h3>No encontramos resultados</h3>
        <p>Proba con otra busqueda o ajusta los filtros.</p>
      </div>
    `;
    return;
  }

  const cards = productos
    .map((producto, index) => {
      const price = getPriceForPresentation(producto);
      const isDisabled = !producto.disponible;
      const isFeatured = producto.destacado === true;
      const cantidad = producto.quantity || producto.cantidad || producto.porciones || 1;
      const presentacion = producto.presentation || producto.presentacion || "porcion";
      const presentationLabel = `${cantidad} ${presentacion}`;
      const imageUrl = producto.imageUrl || producto.imagen || null;
      const productName = producto.nombre || producto.name || "Producto";
      const placeholderUrl =
        imageUrl || `https://placehold.co/400x300?text=${encodeURIComponent(productName)}`;
      const category = producto.categoria || producto.category || "Producto";
      const safeName = escapeHtml(productName);
      const safeCategory = escapeHtml(category);
      const safePresentation = escapeHtml(presentationLabel);
      const cardId = toDomId(producto.id || `${productName}-${index}`);
      const titleId = `card-title-${cardId}`;
      const priceId = `card-price-${cardId}`;
      const statusId = isDisabled || !isStoreOpen ? `card-status-${cardId}` : "";
      const describedBy = [priceId, statusId].filter(Boolean).join(" ");
      const detailButton = `
        <button
          class="card__detail-button"
          data-action="detail"
          type="button"
          aria-label="Ver detalle de ${safeName}"
          aria-haspopup="dialog"
        >
          Ver detalle
        </button>
      `;

      let actionHtml;
      if (isDisabled) {
        actionHtml = `
          
          <span id="${statusId}" class="card__unavailable" role="status">Sin stock</span>
        `;
      } else if (!isStoreOpen) {
        actionHtml = `
          
          <span id="${statusId}" class="card__unavailable card__unavailable--closed" role="status">
            Fuera de horario
          </span>
        `;
      } else {
        actionHtml = `
            <button
            class="btn btn--add"
            data-action="add"
            type="button"
            aria-label="Agregar ${safeName} al pedido"
          >
            Agregar al pedido
          </button>
        `;
      }

      return `
        <article
          class="catalogo-card card"
          data-id="${escapeHtml(producto.id || "")}"
          role="listitem"
          aria-labelledby="${titleId}"
          aria-describedby="${describedBy}"
        >
          ${presentationLabel ? `<div class="card__presentation">${safePresentation}</div>` : ""}
          <span class="card__tag${isFeatured ? " card__tag--featured" : ""}">
            ${safeCategory}
            ${
              isFeatured
                ? '<span class="card__featured-star" title="Destacado" aria-label="Destacado">&#9733;</span>'
                : ""
            }
          </span>
          <div class="card__image-wrapper">
            <button
              type="button"
              class="card__image-button"
              data-action="detail"
              aria-haspopup="dialog"
              aria-label="Ver detalle de ${safeName}"
            >
              <img
                src="${placeholderUrl}"
                alt="${safeName}"
                class="card__image"
                loading="lazy"
                decoding="async"
                onerror="this.style.display='none'; this.parentElement.querySelector('.card__image-placeholder').style.display='flex';"
              >
              <span class="card__image-placeholder" style="display: none;" aria-hidden="true"></span>
              <span class="card__image-hint" aria-hidden="true">Ver detalle</span>
            </button>
          </div>
          <h3 id="${titleId}" class="card__name">${safeName}</h3>
          <div class="card__meta-row">
            <span id="${priceId}" class="card__price">${formatPrice(price)}</span>
            ${detailButton}
          </div>
          <div class="card__actions">
            ${actionHtml}
          </div>
          ${isDisabled ? '<span class="catalogo-card__status">Sin stock</span>' : ""}
        </article>
      `;
    })
    .join("");

  target.innerHTML = cards;
};
